import React, {Component} from 'react';
import {Route, Switch} from 'react-router';

import {Header} from 'semantic-ui-react';

import ScenePlanet from '../scene';
// import {Simple as ScenePlanet} from '../scene';

export default class ScenePlanetContent extends Component {

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return <Switch>
            <Route component={ScenePlanet} exact={true} path="/scene-planet"/>
            <Route>
                <Header as='h1'>Page Not Found on Planet Scene</Header>
            </Route>
        </Switch>;
    }
}


// WEBPACK FOOTER //
// ./src/apps/scene-planet/components/Content.js